const pricing = {
  pricing: {
    pageTitle: 'Pricing',
    pageDescription: 'IOPS SPACE 지상국은 사용한 안테나 시간에 대해서만 비용을 지불합니다. 자세한 사항은 문의해주시기 바랍니다.',
    plans: {
      pass: {
        title: 'PASS plan',
        price: '분당 $2.5',
        description: '위성 궤도에 따라 PASS를 통해 지상국과 통신할 수 있도록 시간 단위로 요금을 지불하세요!'
      },
      rental: {
        title: 'Rental plan',
        price: '출시 예정',
        description: '지상국 전체(H/W와 S/W)를 일정 시간 단위로 대여하여 원하는 만큼 사용하세요!'
      },
      custom: {
        title: 'Custom plan',
        price: '맞춤형',
        description: '전문가와 상의하여 나만의 서비스를 구축해보세요!'
      }
    }
  }
};

export default pricing;
